import React from 'react'
import ReactDOM from 'react-dom'
import domready from 'domready'
import { Provider } from 'react-redux'
import configureStore from '../shared/store'
import { parse } from 'query-string'
import { toggleVideoById } from '../shared/actions/video'
import { showForm } from '../shared/actions/form'

import App from '../shared/App'
const mainMountId = 'du-saa-meg-mount'

const store = configureStore(window.__INITIAL_STATE__)
window.dev = { store }

const params = parse(location.search)

if (typeof params.videoId !== 'undefined') {
  store.dispatch(toggleVideoById(params.videoId))
}

if (typeof params.show !== 'undefined') {
  if (params.show === 'form') {
    store.dispatch(showForm())
  }
}

function render (Component, mountNode, callback) {
  ReactDOM.render(Component, mountNode, callback)
}

function init () {
  const mountNode = document.getElementById(mainMountId)
  render(
    <Provider store={store}>
      <App />
    </Provider>, mountNode)
}

if (module.hot) {
  module.hot.accept()
}

domready(init)



// WEBPACK FOOTER //
// ./src/client/index.js